module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigator"
  }, [_c('div', {
    staticClass: "w-100 d-flex justify-content-between"
  }, [_c('h2', {
    staticClass: "mr-auto"
  }, [_vm._v("Invoices")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "ico ico-calendar fs-large dark mr-3"
  }), _vm._v(" "), _c('date-picker-new', {
    staticClass: "dateRangePicker",
    attrs: {
      "range": true,
      "clearOutside": true,
      "showFromTo": false
    },
    on: {
      "input": _vm.dateRangeChanged
    },
    model: {
      value: (_vm.getInvoicePageFilters.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.getInvoicePageFilters, "dateRange", $$v)
      },
      expression: "getInvoicePageFilters.dateRange"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-feddaa38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-feddaa38"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoices/Navigator.vue
// module id = 2977
// module chunks = 0